<div class="wallet-page">
  <div class="wallet-header">
    <h1>Platform wallet</h1>
    <p>Per network: the platform's own chain balance versus the credit companies writing to it hold.</p>
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (networks().length === 0) {
    <app-empty-state message="No networks configured yet." />
  } @else {
    <table>
      <thead>
        <tr>
          <th>Network</th>
          <th>Platform address</th>
          <th>Platform chain balance</th>
          <th>Total company credit</th>
          <th>Companies</th>
        </tr>
      </thead>
      <tbody>
        @for (n of networks(); track n.network) {
          <tr>
            <td>{{ n.network }}</td>
            <td>{{ n.platformAddress || 'Unavailable' }}</td>
            <td>{{ n.platformChainBalance !== null ? (n.platformChainBalance + ' ' + n.balanceUnit) : 'Unavailable' }}</td>
            <td>{{ n.totalCompanyWalletBalance }}</td>
            <td>{{ n.companyCount }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
